import * as TK from 'components/site/AboutSite/translations/constants';
import { Translations } from 'translations/types';

export const aboutSiteEnUsLocale: Translations = {
  [TK.ABOUT_SITE_EDIT_BUTTON_LABEL]: 'Edit',
  [TK.ABOUT_SITE_PHOTO_ALT]: 'about site banner',
};
